var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chainGroupChartBar",style:({height:_vm.height, width: _vm.width}),attrs:{"id":"myChainGroupChartBar"}})}
var staticRenderFns = []

export { render, staticRenderFns }